jQuery(document).ready(function ($) {
        checkCookie('pop-up-closed');  

  		$('.close').on('click',function(e){
          e.preventDefault();
          checkSubmitedCookie('pop-up-closed');  
           $('#mc_embed_signup form').show();
               $('.popup-title').show();
               $('#mc_embed_signup').css('height','0').css('padding','0');
               $('.thank-you').remove();
               $('.code-text').remove(); 
		});
  
    
  		$('#mc-embedded-subscribe').on('click',function(e){
          setTimeout(function(){
            console.log($('#mce-success-response').attr('style'));
             if($('#mce-success-response').css('display') == 'block'){
          		setCookie('pop-up-closed','submited',365);
               $('#mc_embed_signup form').hide();
               $('.popup-title').hide();
               $('#mc_embed_signup').css('height','250px').css('padding','10px');
               let $newContent = '<h1 class="thank-you">Thanks For Subscribing!</h1><h3 class="code-text">Use code SHFT20 at checkout to get discount<h3>';
               $('#mc_embed_signup').append($newContent);  
	         }
          }, 2000)
		});
});

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function checkCookie(cname) {
           if( getCookie(cname) != 'submited'){
             
    			if(getCookie(cname) != 'closed' ){
                jQuery('#shopify-section-mailchimp-modal').css('display','flex').css('height','100%').css('opacity','1');
    			}
             
  			}
            
        }
        function checkSubmitedCookie(cname) {
           if( getCookie(cname) == 'submited'){
               	$('#shopify-section-mailchimp-modal').css('display','none').css('height',0).css('opacity','0');
            }else{
            	setCookie('pop-up-closed','closed',1);
       			$('#shopify-section-mailchimp-modal').css('display','none').css('height',0).css('opacity','0');
            }
            
        }
